import React from 'react';
import { Box } from '../Box/Box';
import { Stack } from '../Stack/Stack';
import { Title } from '../Title/Title';
export var Section = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var children = _ref.children,
      title = _ref.title;
  return /*#__PURE__*/React.createElement(Stack, {
    spacing: 4,
    ref: ref
  }, /*#__PURE__*/React.createElement(Title, {
    size: "small",
    component: "h2"
  }, title), /*#__PURE__*/React.createElement(Box, null, children));
});